

















import { Component, Prop, Vue } from "vue-property-decorator";
import { Config } from "@/plugins/config";
import { BasicsSubjects } from "@/store/types";

@Component({
  name: "audio-player",
})
export default class AudioPlayer extends Vue {
  @Prop({ default: "" })
  public audioFile!: string;

  @Prop({ default: true })
  public isCdn!: boolean;

  @Prop({ default: 0 })
  public grade!: number;

  @Prop({ default: BasicsSubjects.ELA })
  public subject!: BasicsSubjects;

  public playing: boolean = false;

  get blockedAudio() {
    try {
      return this.subject === BasicsSubjects.Reading && this.grade > 0;
    } catch (e) {
      return false;
    }
  }

  get audio() {
    if (this.isCdn) {
      return Config.Files + this.audioFile;
    } else {
      return this.audioFile;
    }
  }

  public play() {
    const audio: any = this.$refs.audioElm;
    if (audio.paused) {
      audio.play();
      this.playing = true;
    } else {
      audio.pause();
      this.playing = false;
    }
  }

  public onEnded() {
    this.playing = false;
    this.$emit("audio:ended");
  }
}
